import React from 'react';
import PropTypes from 'prop-types';
import withRouter from './../../../../components/WithRouter';
import { withStyles } from "tss-react/mui";
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import { H3 } from 'components/Typography';
import UserProfileHeader from '../UserProfileHeader';
import Grid from '@mui/material/Grid';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import styles from './styles';
import MediaQuery from 'react-responsive';
import m from 'messages';

class AppBarComponent extends React.Component {

    onTabChanged = (event, value) => {
        const { navigate } = this.props;
        navigate(value);
    };

    render() {

        const { classes, cardCheckerCard, shortTitle, longTitle, config } = this.props;
        const isLoggedIn = Boolean(cardCheckerCard);
        const canSwipeCards = isLoggedIn && !cardCheckerCard.displayOnly && (cardCheckerCard.canSwipeCards);
        const canSpotCheck = isLoggedIn && !cardCheckerCard.displayOnly && (cardCheckerCard.canPerformSpotCheck);
        const canAward = canSwipeCards;

        let currentPath = window.location.pathname;
        currentPath = currentPath === '/' ? '/swipes' : currentPath;

        return (
            <AppBar className={classes.appBar}>
                <MediaQuery maxWidth={767}>
                    {(isMobile) =>
                        <Toolbar disableGutters={false} className={classes.toolbar}>
                            <Grid container>
                                <Grid item>
                                    <H3 color="inherit" noWrap className={classes.appBarTitle}>
                                        {isMobile ? shortTitle : longTitle}
                                    </H3>
                                </Grid>
                                <div className={classes.grow} />
                                <Grid item>
                                    <UserProfileHeader
                                        onLogOutClicked={this.props.onLogOutClicked}
                                        onLocationClicked={this.props.onLocationClicked}
                                        onCompetencyRequirementsClicked={this.props.onCompetencyRequirementsClicked}
                                        onShowCardClicked={this.props.onShowCardClicked}
                                        cardCheckerCard={this.props.cardCheckerCard}
                                        config={config}
                                    />
                                </Grid>
                                {isLoggedIn &&
                                    <Grid item xs={12}>
                                        <Tabs
                                            onChange={this.onTabChanged}
                                            value={currentPath}
                                            className={classes.tabs}
                                            variant={isMobile ? 'fullWidth' : 'standard'}
                                            indicatorColor={'secondary'}
                                            textColor={'inherit'} >

                                            {canSwipeCards &&
                                                <Tab label={m.swipes._self} value="/swipes" />
                                            }
                                            {canSpotCheck &&
                                                <Tab label={m.spotCheck._self} value="/spotCheck" />
                                            }
                                            {canAward &&
                                                <Tab label={m.competencies._self} value="/competencies" />
                                            }
                                        </Tabs>
                                    </Grid>
                                }
                            </Grid>
                        </Toolbar>
                    }
                </MediaQuery>
            </AppBar>
        );
    }
}

AppBarComponent.propTypes = {
    onLogOutClicked: PropTypes.func.isRequired,
    onLocationClicked: PropTypes.func.isRequired,
    onShowCardClicked: PropTypes.func.isRequired,
    onCompetencyRequirementsClicked: PropTypes.func.isRequired,
    cardCheckerCard: PropTypes.object,
    actionButton: PropTypes.object,
    baseTitle: PropTypes.string,
    title: PropTypes.string,
    menuVisible: PropTypes.bool,
    onMenuClicked: PropTypes.func,
    longTitle: PropTypes.string,
    shortTitle: PropTypes.string,
    config: PropTypes.object.isRequired
};

const StyledBar = withRouter(withStyles(AppBarComponent,styles));
export default StyledBar;